export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 10

export function getDefaultPagination(
    overrides: { page?: number; size?: number } = {}
): { page: number; size: number } {
    return { page: DEFAULT_PAGE, size: DEFAULT_PAGE_SIZE, ...overrides }
}
